import { render } from "./CamarasTecnicas.vue?vue&type=template&id=552017ce&scoped=true"
import script from "./CamarasTecnicas.vue?vue&type=script&lang=js"
export * from "./CamarasTecnicas.vue?vue&type=script&lang=js"

import "./CamarasTecnicas.vue?vue&type=style&index=0&id=552017ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552017ce"]])

export default __exports__